<template>
  <div class="footerContainer">
    <el-form
      :model="ruleForm"
      :rules="rules"
      ref="ruleForm"
      label-width="0px"
      class="demo-ruleForm"
    >
      <div class="container">
        <div class="menu">
          <el-col :span="6">
            <div class="logo pb-20">
              <img
                style="margin-left: -10px"
                src="@/images/common/logo.png"
                alt=""
              />
            </div>
            <div
              class="pb-20"
              style="
                font-size: 16px;
                font-weight: 300;
                color: #ffffff;
                line-height: 30px;
              "
            >
              凯通物流，立足跨境电商供应链领域，科技赋能合作伙伴，共同打造全程物流供应链服务生态链。鲸宝科技将依托互联网平台，围绕物流、金融、保险等客户需求，不断推出服务产品，持续解决客户痛点，服务生态伙伴，共建共生，共享共赢！
            </div>
            <div class="pb-20">
              <div
                style="
                  width: 98px;
                  height: 36px;
                  line-height: 36px;
                  background: #31adff;
                  border-radius: 1px;
                  font-size: 14px;
                  font-weight: 500;
                  color: #161718;
                  text-align: center;
                "
              >
                关于我们
              </div>
            </div>
          </el-col>
          <el-col :span="6" :offset="1" class="mt-30">
            <div class="pb-40" style="display: flex; align-items: center">
              <span class="title">通讯</span>
            </div>
            <div class="pb-20" style="font-size: 13px">
              订阅我们的时事通讯以获取我们的最新更新和新闻
            </div>
            <el-form-item prop="val">
              <div class="pb-20 seach">
                <el-input
                  v-model="ruleForm.val"
                  placeholder="您的邮件地址"
                ></el-input>
                <span class="color_3B6AFF" @click="submit">
                  <img src="@/images/common//go.png" alt="" />
                </span></div
            ></el-form-item>
          </el-col>
          <el-col :span="5" :offset="1" class="mt-30">
            <div class="pb-35" style="display: flex; align-items: center">
              <span class="title">联系方式</span>
            </div>
            <div
              style="display: flex; align-items: center; padding-bottom: 26px"
            >
              <img
                style="
                  font-size: 0;
                  width: 0.2rem;
                  height: 0.2rem;
                  margin-right: 12px;
                "
                src="@/images/common/adree.png"
                alt=""
              />
              <span
                style="
                  font-size: 14px;
                  font-family: PingFangSC-Regular, PingFang SC;
                  font-weight: 400;
                "
              >
                宁波市鄞州区明楼街道柴家漕巷27号 供销大厦13楼
              </span>
            </div>
            <div class="pb-30" style="display: flex; align-items: center">
              <img
                style="
                  font-size: 0;
                  width: 0.2rem;
                  height: 0.2rem;
                  margin-right: 12px;
                "
                src="@/images/common/phone.png"
                alt=""
              />
              <span style="font-family: DINAlternate-Bold, DINAlternate">
                400-0574-222</span
              >
            </div>

            <div class="pb-10" style="display: flex; align-items: flex-start">
              <img
                style="
                  font-size: 0;
                  width: 0.2rem;
                  height: 0.2rem;
                  margin-right: 12px;
                "
                src="@/images/common/timer.png"
                alt=""
              />
              <div style="display: flex; flex-direction: column">
                <div style="font-size: 14px; color: #fff; font-weight: bold">
                  营业时间
                </div>
                <p style="font-size: 14px; color: #fff">周一至周日9.00-12.00</p>
                <p style="font-size: 14px; color: #fff">13.30-17.30</p>
              </div>
            </div>
            <div style="display: flex">
              <img
                style="
                  font-size: 0;
                  width: 0.2rem;
                  height: 0.2rem;
                  margin-right: 12px;
                "
                src="@/images/icon/e-meil.png"
                alt=""
              />
              <span style="font-family: DINAlternate-Bold, DINAlternate"
                >chris@caton-logistics.com</span
              >
            </div>
          </el-col>
          <el-col :span="3" :offset="1" class="mt-30">
            <div class="pb-35" style="display: flex; align-items: center">
              <span class="title">微信公众号</span>
            </div>
            <div>
              <div
                class="hoverimg"
                style="
                  width: 128px;
                  height: 128px;
                  background: #ffffff;
                  border-radius: 4px;
                "
              >
                <div
                  style="
                    width: 100%;
                    height: 100%;
                    min-width: 90px;
                    overflow: hidden;
                  "
                >
                  <img
                    style="
                      width: 100%;
                      heigin: 100%;
                      opacity: 1;
                      transition: all 0.3s ease-out 0s;
                    "
                    src="@/images/common/qrcode.jpg"
                    alt=""
                  />
                </div>
              </div>
              <!-- <div
              style="
                font-size: 12px;
                font-family: PingFangSC-Light, PingFang SC;
                font-weight: 300;
                color: #ffffff;
              "
              class="mt-10"
            >
              微信扫一扫关注
            </div> -->
            </div>
          </el-col>
        </div>
        <div style="border-top: 1px solid rgba(255, 255, 255, 0.1)"></div>
        <div class="copy" style="margin: 0.2rem auto 0.15rem">
          版权所有© 2021-2025 浙江凯通物流有限公司<a
            href="https://beian.miit.gov.cn"
            target="_blank"
          >
            浙ICP备12039336号-1</a
          >
        </div>
      </div>
    </el-form>
  </div>
</template>

<script>
import { shipcontactus } from "@/api/collect"
export default {
  data () {
    return {
      url: window.location.host,
      ruleForm: {
        val: "",
      }, rules: {
        val: [
          { required: true, message: '请输入邮箱地址', trigger: 'blur' },
          { type: 'email', message: '请输入正确的邮箱地址', trigger: ['blur', 'change'] }
        ],
      }
    }
  },
  props: {},
  mounted () { },
  methods: {
    toPaths1 () {
      window.open("http://gateway.iyoucang.com")
    },
    submit () {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          shipcontactus({ email: this.ruleForm.val, sourceType: "1" })
            .then((res) => {
              if (res.code == "0") {
                this.messageTooltip({
                  showClose: false,
                  message: "提交成功",
                  duration: 3000,
                  type: "success",
                })
                this.ruleForm.val = ""
              } else {
                this.messageTooltip({
                  showClose: false,
                  message: res.msg,
                  duration: 3000,
                  type: "warning",
                })
              }
            })
            .catch((err) => {
              this.messageTooltip({
                showClose: false,
                message: err.msg,
                duration: 3000,
                type: "warning",
              })
            })
        } else {
          console.log('error submit!!')
          return false
        }
      })

    },
  },
};
</script>

<style scoped>
.footerContainer {
  width: 100%;
  min-width: 12rem;
  height: 5rem;
  /* background: url("../../images/common/bottombg.png") no-repeat; */
  background: #192437;
  /* background-size: 100% 100%; */
  padding: 0.6rem 0 0.3rem 0;
  box-sizing: border-box;
  color: #fff;
}
.container {
  width: 12rem;
  /* height: 100%; */
  margin: 0 auto;
  display: flex;
  flex-direction: column;
}
.menu {
  margin-bottom: 0.6rem;
}
.copy,
.copy a {
  text-align: center;
  font-size: 0.14rem;
  color: #ccc;
}

.logo img {
  width: 100%;
  /* height: 47px; */
}
.serviceInfo {
  font-size: 0.24rem;
  font-family: Microsoft YaHei;
  font-weight: bold;
  line-height: 0.18rem;
}
.serviceInfoTime {
  font-size: 0.2rem;
  font-weight: bold;
  margin-bottom: 0.05rem;
}
.menu .title {
  border-bottom: 1px solid #3b6aff;
  font-size: 0.2rem;
  line-height: 0.48rem;
  font-family: PingFangSC-Light, PingFang SC;
  font-weight: 300;
  color: #ffffff;
}
.color_3B6AFF {
  /* display: inline-block; */
  width: 59px;
  height: 40px;
  background: #3b6aff;
  text-align: center;
  /* vertical-align: middle; */
}
.color_3B6AFF img {
  width: 33px;
  height: 33px;
  margin: 3px 0;
}
.seach {
  display: flex;
  align-items: center;
}
</style>
<style>
.seach .input__inner {
  width: 120px;
}

input[type="button"],
input[type="submit"],
input[type="reset"],
input[type="text"],
input[type="tel"] {
  border-radius: 0 !important;
}
.hoverimg:hover img {
  transform: scale(1.1);
}
</style>



// WEBPACK FOOTER //
// src/components/footer/footer.vue